<template>
  <div>
    <h1 class="uk-h4">
      <span data-uk-icon="icon:desktop; ratio:1.2"></span>
      Dashboard
    </h1>
    <div class="uk-grid" data-uk-grid>
      <div class="uk-width-1-1">
        <div
          class="uk-card uk-card-default uk-card-small uk-card-body uk-border-rounded uk-box-shadow-small"
        >
          <div
            class="uk-grid uk-grid-divider uk-grid-medium uk-child-width-1-2@m uk-width-1-1 uk-child-width-1-3@l uk-child-width-1-3@xl"
            data-uk-grid
          >
            <div>
              <span class="uk-text-small">
                <span
                  data-uk-icon="icon:users"
                  class="uk-margin-small-right uk-text-secondary uk-icon"
                ></span>
                <router-link :to="{ name: 'admin.merchant' }" class="uk-link-reset">
                  Händler
                </router-link>
              </span>
              <h1 class="uk-heading-primary uk-margin-remove">
                {{ stats.merchantsTotal }}
              </h1>
              <!--
              <div class="uk-text-small">
                <template v-if="merchantPercentLess">
                  <span class="uk-text-danger uk-icon" data-uk-icon="icon: triangle-down"
                    >{{ merchantPercent }}%</span
                  >
                  weniger als letzte Woche.
                </template>
                <template v-else>
                  <span class="uk-text-success uk-icon" data-uk-icon="icon: triangle-up"
                    >{{ merchantPercent }}%</span
                  >
                  mehr als letzte Woche.
                </template>
              </div>
              -->
            </div>
            <div>
              <span class="uk-text-small">
                <span class="uk-text-secondary">
                  <img src="/img/vehicle.svg" alt="" data-uk-svg style="width:40px;" />
                </span>
                <router-link :to="{ name: 'VehicleIndex' }" class="uk-link-reset">
                  Fahrzeuge
                </router-link>
              </span>
              <h1 class="uk-heading-primary uk-margin-remove">
                {{ stats.vehicles }}
              </h1>
              <div class="uk-text-small">im Bestand</div>
            </div>
            <div>
              <span class="uk-text-small">
                <span
                  data-uk-icon="icon:cart"
                  class="uk-margin-small-right uk-text-secondary uk-icon"
                ></span>
                <router-link :to="{ name: 'admin.orders' }" class="uk-link-reset">
                  Bestellungen
                </router-link>
              </span>
              <h1 class="uk-heading-primary uk-margin-remove">
                {{ stats.saleTotal }}
              </h1>
              <div class="uk-text-small">
                diesen Monat
              </div>
              <!--
              <div class="uk-text-small" v-if="salePercent">
                <template v-if="salePercentLess">
                  <span class="uk-text-danger uk-icon" data-uk-icon="icon: triangle-down"
                    >{{ salePercent }}%</span
                  >
                  weniger als letzten Monat.
                </template>
                <template v-else>
                  <span class="uk-text-success uk-icon" data-uk-icon="icon: triangle-up"
                    >{{ salePercent }}%</span
                  >
                  mehr als letzten Monat.
                </template>
              </div>
              -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div class="uk-grid uk-grid-medium" data-uk-grid>
      <div class="uk-width-1-1">
        <div class="uk-card uk-card-default uk-card-small uk-box-shadow-small">
          <div class="uk-card-header">
            <div class="uk-grid uk-grid-small">
              <div class="uk-width-auto"><h4>Offene Bestellungen</h4></div>
            </div>
          </div>
          <div class="uk-card-body uk-padding-remove">
            <div class="uk-padding-small">
              <div class="uk-grid uk-grid-small uk-flex uk-flex-middle">
                <div class="uk-width-auto">
                  <div class="uk-grid uk-grid-small uk-flex uk-flex-middle" data-uk-grid>
                    <div class="uk-width-medium@m">
                      <merchant-search
                        @selected="onMerchantSelected"
                        :value="$route.query.merchantNumber"
                        :update-route="false"
                      ></merchant-search>
                    </div>
                  </div>
                </div>
                <div class="uk-width-expand" v-if="meta && meta.pagination.total_pages > 1">
                  <pagination
                    :pagination="meta.pagination"
                    @pagination:switched="onPaginationSwitch"
                    :update-route="false"
                  ></pagination>
                </div>
              </div>
            </div>
            <div class="uk-overflow-auto">
              <table
                v-if="sales.length"
                class="uk-table uk-table-divider uk-table-small uk-table-middle uk-table-striped"
              >
                <thead>
                  <tr>
                    <th class="uk-table-shrink">#</th>
                    <th class="uk-table-expand">Name</th>
                    <th class="uk-table-expand">Fahrzeug</th>
                    <th class="uk-table-shrink">Datum</th>
                    <th style="width:25px;" class="uk-text-right"></th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="sale in sales">
                    <tr v-for="(item, key) in sale.items" :key="item.id">
                      <td v-if="key == 0">
                        {{ sale.number }}
                      </td>
                      <td v-else>&nbsp;</td>
                      <td v-if="key == 0" class="uk-text-nowrap">{{ sale.details.company }}</td>
                      <td v-else>&nbsp;</td>
                      <td>
                        {{ item.make }} {{ item.model }} {{ item.edition }}<br />
                        <span class="uk-text-small"> Nr.: {{ item.carId }} </span>
                      </td>
                      <td class="uk-text-nowrap">{{ sale.date }}</td>
                      <td class="uk-text-nowrap" v-if="key == 0">
                        <router-link
                          data-uk-icon="arrow-right"
                          data-uk-tooltip="Bestellung ansehen"
                          :to="{ name: 'admin.order.details', params: { id: sale.id } }"
                        >
                        </router-link>
                      </td>
                      <td v-else>&nbsp;</td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
            <div
              class="uk-padding-small uk-margin-bottom"
              v-if="meta && meta.pagination.total_pages > 1"
            >
              <div class="uk-grid" data-uk-grid>
                <div class="uk-width-expand">
                  <pagination
                    :pagination="meta.pagination"
                    @pagination:switched="onPaginationSwitch"
                    :update-route="false"
                  ></pagination>
                </div>
              </div>
            </div>
            <div class="uk-padding-small" v-if="!sales.length">
              <div class="uk-h5 uk-margin-remove">Keine offenen Bestellungen</div>
            </div>
          </div>
        </div>
      </div>
      <div class="uk-width-1-2@l">
        <div class="uk-card uk-card-default uk-card-small uk-box-shadow-small">
          <div class="uk-card-header">
            <div class="uk-grid uk-grid-small">
              <div class="uk-width-auto"><h4>Anzahl Verkäufe</h4></div>
              <div class="uk-width-expand">
                <div class="uk-text-right">
                  <a 
                    class="uk-text-primary" 
                    data-uk-tooltip="Ausgewählten Zeitraum Exportieren"
                    @click.prevent="printSales()">
                  <span data-uk-icon="download"></span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="uk-card-body uk-padding-remove">
            <div class="uk-padding-small">
              <div class="uk-grid uk-flex uk-flex-middle" data-uk-grid>
                <div class="uk-width-medium@m">
                  <label>Zeitraum</label>
                  <v-date-picker
                    :input-props="{ class: 'uk-input' }"
                    :theme="{
                      datePickerInputDrag: { light: 'uk-input' }
                    }"
                    mode="range"
                    v-model="merchantSoldRange"
                    :attributes="datepickerAttr"
                    title-position="left"
                    :popover="{ visibility: 'click' }"
                    @input="onRangeChange"
                  />
                </div>
                <div class="uk-width-expand@m">
                  <div class="uk-text-right">
                  <label>Gesamt</label><br>
                  <span class="uk-text-bold">{{ soldByRange.total }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="uk-grid" data-uk-grid>
              <div class="uk-width-1-1">
                <div class="uk-overflow-auto" style="max-height:350px;">
                  <table
                    v-if="Object.keys(soldByRange).length"
                    class="uk-table uk-table-divider uk-table-small uk-table-middle uk-table-striped"
                  >
                    <thead>
                      <tr>
                        <th class="uk-table-expand">Händler</th>
                        <th class="uk-table-shrink uk-text-right">Anzahl</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(count, company) in soldByRange.merchants"
                        :key="company"
                        class="uk-visible-toggle"
                      >
                        <td class="uk-text-nowrap">{{ company }}</td>
                        <td class="uk-text-nowrap uk-text-right">{{ count }}</td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="uk-padding-small" v-else>
                    <div class="uk-h5 uk-margin-remove">Keine Verkäufe im gewählten Zeitraum</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="uk-width-1-2@l">
        <div class="uk-card uk-card-default uk-card-small uk-box-shadow-small">
          <div class="uk-card-header">
            <div class="uk-grid uk-grid-small">
              <div class="uk-width-auto"><h4>Umsatz</h4></div>
            </div>
          </div>
          <div class="uk-card-body">
            <div v-if="amountChartData">
              <BarChart :chartdata="amountChartData" :options="amountChartOptions" />
            </div>
          </div>
        </div>
      </div>
      <div class="uk-width-1-2@l">
        <OpenInvoices />
      </div>
      <!--
      <div class="uk-width-1-2@l">
        <div class="uk-card uk-card-default uk-card-small uk-box-shadow-small">
          <div class="uk-card-header">
            <div class="uk-grid uk-grid-small">
              <div class="uk-width-auto"><h4>Fahrzeuge im Warenkorb</h4></div>
            </div>
          </div>
          <div class="uk-card-body">
            
          </div>
        </div>
      </div>
      -->
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import BarChart from '@/components/BarChart'
import SaleService from '../../services/sale.service'
import moment from 'moment'
import Pagination from '@/components/Pagination'
import MerchantSearch from '@/components/MerchantSearch'
import OpenInvoices from '@/components/admin/OpenInvoices'
import Configuration from '@/configuration'
const baseURL = Configuration.value('apiBackend')
import axios from 'axios'

export default {
  data() {
    return {
      meta: null,
      sales: [],
      selectedMerchant: null,
      soldByRange: [],
      soldRange: {
        /*
        start: moment()
          .startOf('month')
          .format('YYYY-MM-DD'),
        end: moment()
          .endOf('month')
          .format('YYYY-MM-DD')
          */
        start: moment()
          .subtract(30, 'days')
          .format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      datepickerAttr: [
        {
          key: 'today',
          highlight: 'true',
          dates: new Date()
        }
      ],
      printingSales: false,
      amountChartOptions: {
        maintainAspectRatio: false,
        responsiveAnimationDuration: 500,
        animation: {
          duration: 2000
        },
        scales: {
          xAxes: [
            {
              ticks: {}
            }
          ],
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                userCallback: function(value) {
                  return new Intl.NumberFormat('de-DE', {
                    style: 'currency',
                    currency: 'EUR'
                  }).format(value)
                }
              }
            }
          ]
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem) {
              return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(
                tooltipItem.yLabel
              )
            }
          }
        },
        title: {
          display: true,
          text: 'Umsatz pro Monat'
        }
      },
      amountChartData: null
    }
  },
  components: {
    BarChart,
    Pagination,
    MerchantSearch,
    OpenInvoices
  },
  computed: {
    ...mapGetters(['stats']),
    salePercent() {
      if (typeof this.stats.sales !== 'undefined' && this.stats.sales.length) {
        return this.stats.sales[this.stats.sales.length - 1]['growth_rate']
      }
      return null
    },
    salePercentLess() {
      return this.salePercent.charAt(0) === '-'
    },
    merchantPercent() {
      if (typeof this.stats.merchants !== 'undefined' && this.stats.merchants.length) {
        return this.stats.merchants[this.stats.merchants.length - 1]['growth_rate']
      }
      return '0'
    },
    merchantPercentLess() {
      return this.merchantPercent.charAt(0) === '-'
    },
    merchantSoldRange: {
      get() {
        return {
          start: moment()
            .subtract(30, 'days')
            .toDate(),
          end: moment().toDate()
        }
      },
      set(value) {
        this.soldRange = {
          start: moment(value.start).format('YYYY-MM-DD'),
          end: moment(value.end).format('YYYY-MM-DD')
        }
      }
    }
  },
  mounted() {
    this.getStats()
    this.getAmountPerMonth()
    this.getPending()
    this.getCountByRange()
  },
  /*
  watch: {
    '$route.query'() {
      this.getPending()
    }
  },
  */
  methods: {
    ...mapActions(['getStats']),
    async getPending(query) {
      const sales = await SaleService.getPending({ ...query })
      this.sales = sales.data.sales
      this.meta = sales.data.meta
    },
    async getCountByRange() {
      const sales = await SaleService.countByRange(this.soldRange)
      this.soldByRange = sales.data
    },
    onRangeChange() {
      this.getCountByRange()
    },
    onPaginationSwitch(page) {
      this.getPending({ page: page, merchantNumber: this.selectedMerchant })
    },
    onMerchantSelected(merchant) {
      this.getPending({ merchantNumber: merchant.number })
      this.selectedMerchant = merchant.number
    },
    getAmountPerMonth() {
      SaleService.getAmountPerMonth().then(response => {
        const amount = response.data
        this.amountChartData = {
          labels: amount.map(a => a.date),
          datasets: [
            {
              label: 'Aktuelles Jahr',
              backgroundColor: '#737373',
              data: amount.map(a => a.total)
            }
          ]
        }
      })
    },
    printSales() {
      this.printingSales = true
      axios({
        url: `${baseURL}/statistic/print-sales`,
        method: 'GET',
        responseType: 'blob',
        params: this.soldRange
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `Verkäufe-${this.soldRange.start}_${this.soldRange.end}.csv`)
        document.body.appendChild(link)
        link.click()
        this.printingSales = false
      })
    },
  }
}
</script>
